'use client';

import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { prizePoolState, feesPoolState, selectedProjectDataState } from '@/lib/state';
import { lamportsToToken } from '@/lib/utils';

export default function PrizePool({ showPot, showFeesPot, token, decimals }) {
  const potData = useRecoilValue(prizePoolState);
  const feesPotData = useRecoilValue(feesPoolState);
  const projectData = useRecoilValue(selectedProjectDataState);

  const prizePot = useMemo(() => {
    if (potData?.pot) {
      return Number(potData.pot).toLocaleString();
    }
    if (!projectData) {
      return null;
    }
    return Number(lamportsToToken(decimals, projectData?.min_pot_size || 0)).toLocaleString();
  }, [potData, projectData, decimals]);

  const feesPot = useMemo(() => {
    if (feesPotData?.pot) {
      return Number(feesPotData.pot).toLocaleString();
    }
    if (!projectData) {
      return null;
    }
    return Number(lamportsToToken(decimals, projectData?.min_fees_pot_size || 0)).toLocaleString();
  }, [feesPotData, projectData, decimals]);

  if (!(showPot || showFeesPot)) {
    return null;
  }

  return (
    <div className="flex flex-col items-center w-full border-b border-neutral bg-base-100 rounded-t">
      {showPot && (
        <div className="flex w-full items-center justify-between px-4 pt-4">
          <h2 className="text-xl">👑 {token} Pool:</h2>
          {prizePot ? (
            <p className="text-xl font-bold">
              {prizePot} {token}
            </p>
          ) : (
            <div className="bg-gray-300 animate-pulse w-32 h-8 rounded px-4 pb-4" />
          )}
        </div>
      )}
      {showFeesPot && (
        <div className="flex w-full items-center justify-between p-4">
          <h2 className="text-xl">🏆 SOL Pool:</h2>
          {feesPot ? (
            <p className="text-xl font-bold">{feesPot} SOL</p>
          ) : (
            <div className="bg-gray-300 animate-pulse w-32 h-8 rounded" />
          )}
        </div>
      )}
    </div>
  );
}
